import React, {useEffect, useState} from "react";
import MaduLagoonTour from "./MaduLagoonTour";
import BottomActionBar from "./BottomActionBar";

const TravelPackages = () => {

    const [showActionBar, setShowActionBar] = useState(true);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
<>
    <BottomActionBar visible={showActionBar} />

    <div className="p-6 space-y-10 max-w-5xl mx-auto mt-14">
        <h1 className="text-3xl font-bold text-center text-green-800 mt-20 md:mt-10 lg:mt-0">
            <strong>My Travel Packages</strong>
        </h1>

            {/* Airport Transfer */}
            <section className="bg-white p-5 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">✈️ Airport Pickup & Drop</h2>
                <p className="text-gray-600"><strong>Colombo Airport</strong></p>
                <p className="text-gray-600">Car 🚙 65€ &nbsp; | &nbsp; Van 🚐 75€</p>
                <p className="text-gray-600"><strong>Mattala Airport</strong></p>
                <p className="text-gray-600">Car 🚙 80€ &nbsp; | &nbsp; Van 🚐 95€</p>
            </section>

            {/* Ambalangoda City Tour */}
            <section className="bg-white p-5 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">🏙️ Ambalangoda City</h2>
                <p className="text-gray-600">ATM, Money Exchange, Ayurvedic Medicine Pharmacy</p>
                <p className="text-gray-600">Tuk Tuk 🛺 (Go & Back, 1 hour waiting): <strong>2€</strong></p>
            </section>


            <MaduLagoonTour/>


            {/* Less Than 5 Hours Tours */}
            <section>
                <h2 className="text-2xl font-bold text-green-700 mt-8 mb-4">🕔 Less Than 5 Hours Tours</h2>

                <div className="space-y-4">

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">Line Buddha temple </h3>
                        <p> (Go & Back, 2 hour waiting) <p>Tuk Tuk: 5€ | Car: 10€ | Van: 20€</p>
                            <strong> One
                                ticket</strong> 🎟 <strong>1.66$</strong>
                        </p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🐢 Turtle Farm </h3>
                        <p> Tuk Tuk 🛺(Go & Back, 1 hour waiting) <strong>2€.</strong> <strong> One
                            ticket</strong> 🎟 <strong>3.33$</strong>
                        </p>
                    </div>
                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🌙 Moonstone Mine Tour (2 hrs)</h3>
                        <p>Tuk Tuk: 3.67€ | Car: 10€ | Van: 15€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🌳 Moonstone Mine & Jungle Meditation Monastery Buddha
                            Temple (3 hrs)</h3>
                        <p>Tuk Tuk: 4€ | Car: 10€ | Van: 15€</p>
                    </div>


                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold"></h3>
                        <p>Line Buddha Temple, Cinnamon Garden, Tea Land , WaterFall <strong>(3.5 hrs)</strong></p>
                        <p>Tuk Tuk: 15€ | Car: 30€ | Van: 40€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold"></h3>
                        <p> Tea Land , WaterFall <strong>(3 hrs)</strong></p>
                        <p>Tuk Tuk: 15€ | Car: 30€ | Van: 40€</p>
                        <strong> One
                            ticket</strong> 🎟 <strong>3.33$</strong>
                    </div>


                    <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🏞️ Village Tour (4 hrs)</h3>
                        <p>Includes: Line Buddha Temple, Cinnamon Garden, Tea Land , Turtle Farm , Moonstone</p>
                        <p>Tuk Tuk: 10€ | Car: 20€ | Van: 35€</p>
                    </div>


                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">☕ Ahangama Tea Factory</h3>
                        <p>Car: 55€ | Van: 60€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🛍️ Hikkaduwa Shopping (4 hrs)</h3>
                        <p>Includes: Moonstone Mine, Tsunami Museum, Msunami Memorial, Buddha Statue, God Temple</p>
                        <p>Tuk Tuk: 8€ | Car: 17€ | Van: 20€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🛍️ Galle Dutch Fort (5 hrs)</h3>
                        <p>Includes:Moonstone Mine,Tsunami Museum,Tsunami Memorial,Buddha Statue,God Temple,Hikkaduwa
                            City,Silk Factory,Gems Museum,Shiwa Kovil</p>
                        <p>Tuk Tuk: 15€ | Car: 30€ | Van: 40€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🏖️ Unawatuna Beach (4 hrs)</h3>
                        <p>Tuk Tuk: 20€ | Car: 40€ | Van: 50€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🧵 Silk Factory Tour (2.5 hrs)</h3>
                        <p>Tuk Tuk: 13€ | Car: 25€ | Van: 35€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🌅 Dewndura Lighthouse (4 hrs)</h3>
                        <p>Car: 70€ | Van: 75€</p>
                    </div>


                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🛍️ Bentota Shopping (4 hrs)</h3>
                        <p>Tuk Tuk: 15€ | Car: 25€ | Van: 30€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🛕 Kandevihara Temple & Elephant (4 hrs)</h3>
                        <p>Tuk Tuk: 15€ | Car: 30€ | Van: 35€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🌿 Bawa Garden Tour (4 hrs)</h3>
                        <p>Tuk Tuk: 14€ | Car: 25€ | Van: 30€</p>
                        <p>Visit Time : 11.00 am | 2.00 pm | 3.00 pm</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🌱 Briff Garden Tour (4 hrs)</h3>
                        <p>Tuk Tuk: 15€ | Car: 30€ | Van: 35€</p>
                    </div>

                    <div className="bg-green-50 shadow-lg rounded-xl p-6 max-w-xl mx-auto">
                        <h2 className="text-2xl font-bold mb-4 text-gray-800">🎟️ Bawa Garden & Briff Garden Ticket
                            Prices</h2>
                        <ul className="space-y-4 text-gray-800 font-medium">
                            <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                                <div className="flex justify-between sm:block">
                                    <span>🎫 Bawa Garden</span>
                                    <span className="text-right font-semibold sm:hidden">20$</span>
                                </div>
                                <span className="text-sm text-gray-600">1 Ticket</span>
                                <span className="text-right font-semibold hidden sm:block">20$</span>
                            </li>
                            <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                                <div className="flex justify-between sm:block">
                                    <span>🎫 Briff Garden</span>
                                    <span className="text-right font-semibold sm:hidden">10$</span>
                                </div>
                                <span className="text-sm text-gray-600">1 Ticket</span>
                                <span className="text-right font-semibold hidden sm:block">10$</span>
                            </li>
                        </ul>
                    </div>


                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🌴 DAY TOUR (7 hrs) Hikkaduwa-Galle-Unawatuna-Thalpe
                            Beach-Ahangama Tea Factory </h3>
                        <p>Car: 60€ | Van: 70€</p>
                    </div>

                    <div className="bg-white p-4 rounded-xl shadow">
                        <h3 className="text-lg font-semibold">🐳 Mirissa whale & Dolphins 🐬 watching,coconut tree 🌴
                            hill,Mirissa beach (9 hrs)</h3>
                        <p>Boat: Adult $50 | Child $30</p>
                        <p>Car: 55€ | Van: 60€</p>
                    </div>
                </div>
            </section>

        {/* More Than 10 Hours Tours */}
        <section>
            <h2 className="text-2xl font-bold text-green-700 mt-8 mb-4">🔟+ Hour Tours</h2>

            <div className="space-y-4">

                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🛒 Colombo City Shopping Tour (10 hrs)</h3>
                    <p>Car: 65€ | Van: 70€</p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🌧️ Sinharaja Rainforest (10 hrs)</h3>
                    <p>Car: 90€ | Van: 100€</p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🫖 Nuwara Eliya - Tea Plantation & Factory (17 hrs)</h3>
                    <p>Car: 200€ | Van: 225€</p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🐘 Kandy Tour (15 hrs)</h3>
                    <p>Includes: Pinnawala Elephant orphanage, Flower Garden, Temple of Tooth,Kandy Dancing Show</p>
                    <p>Car: 150€ | Van: 190€</p>
                </div>

                <div className="bg-green-50 p-6 rounded-xl shadow-lg max-w-xl mx-auto">
                    <h2 className="text-2xl font-bold mb-4 text-gray-800">🎟️ Kandy Ticket Prices</h2>
                    <ul className="space-y-3 text-gray-800 font-medium">
                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Pinnawala Elephant orphanage</span>
                                <span className="text-right font-semibold sm:hidden">16$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">16$</span>
                        </li>

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Peradeniya Flower Garden</span>
                                <span className="text-right font-semibold sm:hidden">9$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">9$</span>
                        </li>

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Temple of Tooth</span>
                                <span className="text-right font-semibold sm:hidden">6.66$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">6.66$</span>
                        </li>

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Kandy Dancing Show</span>
                                <span className="text-right font-semibold sm:hidden">11$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">11$</span>
                        </li>

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Ambuluwawa Tower</span>
                                <span className="text-right font-semibold sm:hidden">3.33$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">3.33$</span>
                        </li>

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🛺 Tuk tuk</span>
                                <span className="text-right font-semibold sm:hidden">5$</span>
                            </div>
                            <span className="text-sm text-gray-600">Transport</span>
                            <span className="text-right font-semibold hidden sm:block">5$</span>
                        </li>
                    </ul>
                </div>


                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🦁 Sigiriya Lion Rock & Dambulla Golden Temple(15 hrs)</h3>
                    <p>Car: 175€ | Van: 220€</p>
                </div>
                <div className="bg-green-50 shadow-lg rounded-xl p-6 max-w-xl mx-auto">
                    <h2 className="text-2xl font-bold mb-4 text-gray-800">🎟️ Sigiri & Dambulla Ticket Prices</h2>
                    <ul className="space-y-4 text-gray-800 font-medium">

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Sigiriya</span>
                                <span className="text-right font-semibold sm:hidden">35$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">35$</span>
                        </li>

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Sigiriya (Child)</span>
                                <span className="text-right font-semibold sm:hidden">20$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">20$</span>
                        </li>

                        <li className="flex flex-col sm:grid sm:grid-cols-3 gap-1 sm:gap-4">
                            <div className="flex justify-between sm:block">
                                <span>🎫 Dambulla</span>
                                <span className="text-right font-semibold sm:hidden">7$</span>
                            </div>
                            <span className="text-sm text-gray-600">1 Ticket</span>
                            <span className="text-right font-semibold hidden sm:block">7$</span>
                        </li>

                    </ul>
                </div>


                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🌊 Ella Tour (10 hrs)</h3>
                    <p>Rawana Waterfall, Nine Arch Bridge, Ella Town, Train Tour</p>
                    <p>Car: 134€ | Van: 200€</p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🐯 Yala National Park (7 hrs)</h3>
                    <p> Car: 100€ | Van: 150€</p>
                    <p>Safari Jeep: 50$ </p>
                    <p>Tickets: 1 - 44$, 2 - 73$, 3 - 102$</p>
                    <p>There are two departure times for visiting Yala, one is at 6am and the other is at 2pm. If
                        you are going to visit in the morning, you should start your journey at 4.15am from the
                        hotel where you are staying. When you return, you can get the treatment you missed in the
                        morning in the evening. If you are going to visit in the afternoon, you should start your
                        journey from the hotel at 11.10am after your morning treatment.</p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🐘 Udawalawa National Park (7 hrs)</h3>
                    <p>Car: 100€ | Van: 150€</p>
                    <p> Safari Jeep: 40$ </p>
                    <p>Tickets: 1 - 44$, 2 - 73$, 3 - 102$</p>
                    <p></p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <p><strong>When you tell the hotel what breakfast and lunch you choose for your trip, they will
                        prepare it for you to take away and eat on the way 🍱🍽 </strong></p>
                </div>

                <div
                    className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-xl shadow-md max-w-md mx-auto">
                    <h2 className="text-2xl font-bold text-yellow-700 mb-4 text-center">
                        🎫 Yala & Udawalawa National Park Ticket Prices
                    </h2>

                    <ul className="space-y-2 text-gray-800 font-medium">
                        <li className="flex justify-between">
                            <span>1 Ticket</span> <span>44$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>2 Tickets</span> <span>73$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>3 Tickets</span> <span>102$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>4 Tickets</span> <span>132$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>5 Tickets</span> <span>162$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>6 Tickets</span> <span>191$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>7 Tickets</span> <span>220$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>8 Tickets</span> <span>263$</span>
                        </li>
                        <li className="flex justify-between">
                            <span>9 Tickets</span> <span>292$</span>
                        </li>
                        <li className="flex justify-between font-semibold text-yellow-800">
                            <span>10 Tickets</span> <span>345$</span>
                        </li>
                    </ul>

                    <div className="mt-6 border-t border-yellow-300 pt-4 text-center">
                        <p className="text-md font-semibold text-yellow-700">Children (Ages 6–12):</p>
                        <p className="text-lg font-bold text-yellow-800">1 Ticket – 17$</p>
                    </div>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🏞️ Ella & Yala Tour (13 hrs)</h3>
                    <p>Includes: Rawana Waterfall, Nine Arch Bridge, Ella Town, Train 🚂 Tour + Yala National Park
                        🏞️</p>
                    <p>Car 🚗: 134€ + 30€<br/>Van 🚐: 200€ + 40€</p>
                </div>
                <div className="bg-white p-4 rounded-xl shadow">
                    <h3 className="text-lg font-semibold">🏞️ Ella & Udawalawa Tour (13 hrs)</h3>
                    <p>Includes: Rawana Waterfall, Nine Arch Bridge, Ella Town, Train 🚂 Tour + Udawalawa National
                        Park 🏞️</p>
                    <p>Car 🚗: 134€ + 30€<br/>Van 🚐: 200€ + 40€</p>
                </div>


                <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded-xl shadow-md space-y-4">
                    <h3 className="text-lg font-bold text-green-700">📍 Highlighted Travel Destinations</h3>

                    <div className="bg-white p-3 rounded-lg shadow-inner">
                        <ul className="list-disc list-inside text-gray-800 space-y-1">
                            <li>Anuradhapura</li>
                            <li>Polonnaruwa</li>
                            <li>Trincomalee Beach 🏝</li>
                            <li>Pasi kuda</li>
                            <li>Pothuvil</li>
                            <li>Jaffna</li>
                            <li>Arugam Bay</li>
                            <li>Kitulgala</li>
                            <li>Negombo</li>
                        </ul>
                    </div>
                </div>


                <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-xl shadow-md space-y-3">
                    <h3 className="text-lg font-bold text-blue-700">🌍 Long Tours (More Than 5 Days)</h3>
                    <p className="text-gray-800">
                        For tours longer than five 5 days, you have <span className="font-semibold text-blue-700">two flexible options</span> to
                        choose from:
                    </p>

                    <div className="bg-white rounded-lg p-3 shadow-inner">
                        <p className="font-semibold text-gray-900 mb-1">🔹 Option 1 – Per Day Rate:</p>
                        <ul className="list-disc list-inside text-gray-800">
                            <li>Car 🚗: <span className="font-bold">80 € / day</span></li>
                            <li>Van 🚐: <span className="font-bold">96 € / day</span></li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-lg p-3 shadow-inner">
                        <p className="font-semibold text-gray-900 mb-1">🔹 Option 2 – Per Kilometer Rate:</p>
                        <ul className="list-disc list-inside text-gray-800">
                            <li>Car 🚗: <span className="font-bold">0.37 € / km</span></li>
                            <li>Van 🚐: <span className="font-bold">0.44 € / km</span></li>
                        </ul>
                    </div>
                </div>


                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-xl shadow-md space-y-2">
                    <h3 className="text-lg font-bold text-yellow-700">📢 Important Travel Info</h3>
                    <p className="text-gray-800">
                        If you like to travel 🧭🧳, you'll be charged <span className="font-semibold text-yellow-700">per km 💰</span>.
                    </p>
                    <p className="text-gray-800">
                        If you stay in one place for more than one night, you will be charged <span
                        className="font-semibold text-yellow-700">per day</span>.
                    </p>
                    <div className="bg-white rounded-lg p-3 shadow-inner">
                        <p className="text-gray-900 font-medium">Rates:</p>
                        <ul className="list-disc list-inside text-gray-800">
                            <li>Car 🚗: <span className="font-bold">55 € / day</span></li>
                            <li>Van 🚐: <span className="font-bold">60 € / day</span></li>
                        </ul>
                    </div>
                </div>


                <div
                    className="p-1 rounded-xl bg-gradient-to-r from-green-400 via-green-500 to-green-600 max-w-xl mx-auto">
                    <div className="bg-green-50 border-l-8 border-green-700 p-6 rounded-lg shadow-lg">
                        <h3 className="text-xl font-semibold text-green-900 mb-2">Need a Guide?</h3>
                        <p className="text-green-800 text-base leading-relaxed">
                            Dear Sir/Madam, if you need a guide, we will provide it.
                            <br/>
                            <span className="font-semibold">You will have to pay the guide 17 euros.</span>
                        </p>
                    </div>
                </div>


            </div>
        </section>


    </div>
</>
    );
};

export default TravelPackages;
